import { h } from "preact";
import { withStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import palette from "./palette";

// The `withStyles()` higher-order component is injecting a `classes`
// prop that is used by the `Button` component.
const NavPrimaryButton = withStyles({
	root: {
		color: palette.primary.main,
		fontWeight: "bold",
		marginRight: "20px",
	},
	label: {
		textTransform: "capitalize",
	},
})(Button);

export default NavPrimaryButton;
